import _ from 'lodash'

/**
 * createBasicPlanTaxRate
 * @param {ReturnType<import('core/data/data-wrapper')._DB>} dataWrapper
 */
export function createBasicPlanTaxRate(dataWrapper) {
  const _lookUpBasicTaxRate = (allTaxRates, basicPlan, gender, age, coveragePeriod) => {
    const basicPlanTaxRates = allTaxRates.find(({ productCode }) => productCode === basicPlan.basicPlanCode)
    if (!basicPlanTaxRates) {
      return { retire: 0, life: 0, health: 0 }
    }
    const ageValue = age.unit !== 'year' ? 0 : age.value
    const coveragePeriodQuery = coveragePeriod < 10 ? 0 : 10
    const queryParams = [
      ['gender', gender],
      ['age', ageValue],
      ['coveragePeriod', coveragePeriodQuery],
    ].filter(([key]) => basicPlanTaxRates.criteria.includes(key.toString()))
    const queryParamsPath = _.flatten(queryParams)
    return _.get(basicPlanTaxRates, queryParamsPath, { retire: 0, life: 0, health: 0 })
  }

  const lookUpBasicTaxRate = (basicPlan, gender, age, coveragePeriod) => {
    return dataWrapper.getTaxRates().then((allTaxRates) => {
      return _lookUpBasicTaxRate(allTaxRates, basicPlan, gender, age, coveragePeriod)
    })
  }

  return {
    _lookUpBasicTaxRate,
    lookUpBasicTaxRate,
  }
}
